import React from "react";
import moment from "moment";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import ActionLink from "components/ActionLink";
import { getTickets } from "./_actions";
import EditSupportTicketModal from "./EditSupportTicketModal";
import { openSupportModal } from "./_actions";

class MySupportTickets extends React.Component {
    state = {};

    componentDidMount() {
        this.props.getTickets();
    }

    selectTicket = (ticket) => (e) => {
        this.setState({ selectedTicket: ticket }, () => this.props.openSupportModal("EditSupportTicketModal"));
    };

    render() {
        const { tickets, isLoading, addTicket, modal } = this.props;

        const hasTickets = (tickets.length || []) > 0;

        return (
            <React.Fragment>
                <Panel loading={isLoading}>
                    <PanelBody>
                        <div className="Table">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="th--shrink">Id</th>
                                        <th className="th--shrink">Status</th>
                                        <th data-width="20">Subject</th>
                                        <th data-width="30">Request</th>
                                        <th data-width="12.5">Modified</th>
                                        {false && <th data-width="30">Context</th>}
                                        {true && <th className="th--shrink">Comments</th>}
                                    </tr>
                                </thead>
                                {!hasTickets && (
                                    <tbody>
                                        <tr>
                                            <td colSpan="7">
                                                <div className="Tile-body">
                                                    <div className="Tile-body-message">
                                                        <h4 className="u-mt-0">You have no existing support tickets</h4>
                                                        <ActionLink id="add-ticket" className="IconLink--arrow-plus Button Button--sm u-mt-md" onClick={addTicket}>
                                                            Request support
                                                        </ActionLink>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                                {hasTickets && (
                                    <tbody>
                                        {tickets.map((ticket, i) => {
                                            const hasSyncedWithZendesk = ticket.id !== undefined;
                                            const descriptionLines = ticket.description.split("\n");
                                            const modified = ticket.comments.reduce((result, comment) => {
                                                if (comment.created_at) {
                                                    const createdAt = moment(comment.created_at);
                                                    if (!result || result.diff(createdAt) < 0) result = createdAt;
                                                }
                                                return result;
                                            }, null);

                                            const selected = this.state.selectedTicket && ((this.state.selectedTicket.id && this.state.selectedTicket.id === ticket.id) || (this.state.selectedTicket.tempId && this.state.selectedTicket.tempId === ticket.tempId));
                                            return (
                                                <tr key={"ticket-" + i} className={`${hasSyncedWithZendesk ? "u-link" : ""} ${selected ? "Table-tr--blue is-selected" : "hover"}`} onClick={hasSyncedWithZendesk ? this.selectTicket(ticket) : undefined} valign="top">
                                                    <td className={hasSyncedWithZendesk ? "a" : ""}>{ticket.id ? ticket.id : "-"}</td>
                                                    <td>{ticket.status}</td>
                                                    <td>{ticket.subject}</td>
                                                    <td>
                                                        {descriptionLines.map((line, i) => (
                                                            <p key={i}>{line}</p>
                                                        ))}
                                                    </td>
                                                    <td>{modified ? modified.format("D MMM, YYYY, h:mmA") : "-"}</td>
                                                    <td className="u-textCenter">{ticket.comments.length || "-"}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </PanelBody>
                </Panel>
                {modal === "EditSupportTicketModal" && <EditSupportTicketModal viewModel={this.state.selectedTicket} />}
            </React.Fragment>
        );
    }
}
export default compose(
    withAppContext,
    withActions({ getTickets, openSupportModal }),
    withState((state) => {
        return {
            modal: state.support.modal,
            tickets: state.support.tickets,
        };
    })
)(MySupportTickets);
